import React, { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Función auxiliar para convertir fecha ISO a YYYY-MM-DD
const formatDateForInput = (dateString) => {
	if (!dateString) return '';
	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return '';
		return date.toISOString().split('T')[0];
	} catch {
		return '';
	}
};

export function LaboralExperiences({ laboralExperiences = [], onUpdate }) {
	const [modalOpen, setModalOpen] = useState(false);
	const [editingIndex, setEditingIndex] = useState(null);
	const [formData, setFormData] = useState({
		nombreCompania: '',
		cargo: '',
		esActual: false,
		fechaInicio: '',
		fechaFin: '',
		descripcionLabores: ''
	});

	const handleOpenModal = (index = null) => {
		if (index !== null) {
			// Editar experiencia existente
			const exp = laboralExperiences[index];
			setFormData({
				nombreCompania: exp.nombreCompania || '',
				cargo: exp.cargo || '',
				esActual: exp.esActual || false,
				fechaInicio: formatDateForInput(exp.fechaInicio),
				fechaFin: formatDateForInput(exp.fechaFin),
				descripcionLabores: exp.descripcionLabores || ''
			});
			setEditingIndex(index);
		} else {
			// Nueva experiencia
			setFormData({
				nombreCompania: '',
				cargo: '',
				esActual: false,
				fechaInicio: '',
				fechaFin: '',
				descripcionLabores: ''
			});
			setEditingIndex(null);
		}
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
		setEditingIndex(null);
		setFormData({
			nombreCompania: '',
			cargo: '',
			esActual: false,
			fechaInicio: '',
			fechaFin: '',
			descripcionLabores: ''
		});
	};

	const handleSave = () => {
		if (!formData.nombreCompania || !formData.cargo || !formData.fechaInicio) {
			alert('Por favor completa los campos requeridos: Nombre de la Compañía, Cargo y Fecha de Inicio');
			return;
		}

		const newExperience = {
			nombreCompania: formData.nombreCompania,
			cargo: formData.cargo,
			esActual: formData.esActual,
			fechaInicio: formData.fechaInicio,
			fechaFin: formData.esActual ? null : (formData.fechaFin || null),
			descripcionLabores: formData.descripcionLabores || null
		};

		let updatedExperiences;
		if (editingIndex !== null) {
			// Actualizar experiencia existente
			const existingExp = laboralExperiences[editingIndex];
			updatedExperiences = [...laboralExperiences];
			updatedExperiences[editingIndex] = {
				...existingExp,
				...newExperience
			};
		} else {
			// Agregar nueva experiencia
			updatedExperiences = [...laboralExperiences, newExperience];
		}

		if (onUpdate) {
			onUpdate(updatedExperiences);
		}
		handleCloseModal();
	};

	const handleDelete = (index) => {
		if (window.confirm('¿Estás seguro de que deseas eliminar esta experiencia laboral?')) {
			const updatedExperiences = laboralExperiences.filter((_, i) => i !== index);
			if (onUpdate) {
				onUpdate(updatedExperiences);
			}
		}
	};

	const formatDateRange = (fechaInicio, fechaFin, esActual) => {
		if (!fechaInicio) return '';
		const startDate = new Date(fechaInicio);
		const startStr = startDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });

		if (esActual) {
			return `${startStr} - Actualidad`;
		} else if (fechaFin) {
			const endDate = new Date(fechaFin);
			const endStr = endDate.toLocaleDateString('es-ES', { month: 'short', year: 'numeric' });
			return `${startStr} - ${endStr}`;
		}
		return startStr;
	};

	return <div id="employment_bx" className="job-bx bg-white m-b30 ">
		<div className="d-flex">
			<h5 className="m-b15">Experiencias Laborales</h5>
			<Link to={"#"} onClick={() => handleOpenModal(null)} className="site-button add-btn button-sm"><i className="bi bi-plus"></i> Nueva</Link>
		</div>
		{laboralExperiences.length > 0 ? (
			<div className='list-row'>
				{laboralExperiences.map((exp, index) => (
					<div key={exp.id || index} className='list-line'>
						<div className='d-flex justify-content-between'>
							<h6 className="font-14 m-b0">{exp.cargo || 'Sin cargo especificado'}</h6>
							<div>
								<span onClick={() => handleOpenModal(index)} className="site-button add-btn button-sm mr-2"><i className="fa fa-pencil m-r5"></i> Editar</span>
								<span onClick={() => handleDelete(index)} className="site-button add-btn button-sm" style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}><i className="fa fa-trash m-r5"></i> Eliminar</span>
							</div>
						</div>
						<p className="m-b0">{exp.nombreCompania || 'Sin compañía especificada'}</p>
						<p className="m-b0">{formatDateRange(exp.fechaInicio, exp.fechaFin, exp.esActual)}</p>
						{exp.descripcionLabores && (
							<p className="m-b0">{exp.descripcionLabores}</p>
						)}
					</div>
				))}
			</div>
		) : (
			<p className="m-b0">No has agregado experiencias laborales aún. Haz clic en "Nueva" para agregar una.</p>
		)}

		<Modal show={modalOpen} onHide={handleCloseModal} className="modal fade modal-bx-info editor" >
			<div className="modal-dialog my-0" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="EmploymentModalLongTitle">
							{editingIndex !== null ? 'Editar Experiencia Laboral' : 'Agregar Nueva Experiencia Laboral'}
						</h5>
						<button type="button" className="close" onClick={handleCloseModal}>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div className="modal-body">
						<form>
							<div className="row">
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Nombre de la Compañía *</label>
										<input
											type="text"
											className="form-control"
											placeholder="Introduce el nombre de la compañía"
											value={formData.nombreCompania}
											onChange={(e) => setFormData({ ...formData, nombreCompania: e.target.value })}
										/>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Tu Cargo en la Compañía *</label>
										<input
											type="text"
											className="form-control"
											placeholder="Introduce tu cargo"
											value={formData.cargo}
											onChange={(e) => setFormData({ ...formData, cargo: e.target.value })}
										/>
									</div>
								</div>

								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>¿Es esta tu actual compañía?</label>
										<div className="row">
											<div className="col-lg-6 col-md-6 col-sm-6 col-6">
												<div className="custom-control custom-radio">
													<input
														type="radio"
														className="custom-control-input"
														id="employ_yes"
														name="esActual"
														checked={formData.esActual === true}
														onChange={() => setFormData({ ...formData, esActual: true, fechaFin: '' })}
													/>
													<label className="custom-control-label" htmlFor="employ_yes">Sí</label>
												</div>
											</div>
											<div className="col-lg-6 col-md-6 col-sm-6 col-6">
												<div className="custom-control custom-radio">
													<input
														type="radio"
														className="custom-control-input"
														id="employ_no"
														name="esActual"
														checked={formData.esActual === false}
														onChange={() => setFormData({ ...formData, esActual: false })}
													/>
													<label className="custom-control-label" htmlFor="employ_no">No</label>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Fecha de Inicio *</label>
										<input
											type="date"
											className="form-control"
											value={formData.fechaInicio}
											onChange={(e) => setFormData({ ...formData, fechaInicio: e.target.value })}
										/>
									</div>
								</div>
								{!formData.esActual && (
									<div className="col-lg-12 col-md-12">
										<div className="form-group">
											<label>Fecha de Fin</label>
											<input
												type="date"
												className="form-control"
												value={formData.fechaFin}
												onChange={(e) => setFormData({ ...formData, fechaFin: e.target.value })}
											/>
										</div>
									</div>
								)}
								<div className="col-lg-12 col-md-12">
									<div className="form-group">
										<label>Describe Tus Labores en esta Empresa:</label>
										<textarea
											className="form-control"
											placeholder="Introduce tus labores en esta empresa"
											value={formData.descripcionLabores}
											onChange={(e) => setFormData({ ...formData, descripcionLabores: e.target.value })}
											rows="4"
										></textarea>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="site-button" onClick={handleCloseModal} >Cancelar</button>
						<button type="button" className="site-button" onClick={handleSave}>Guardar</button>
					</div>
				</div>
			</div>
		</Modal>
	</div >
}
